import React from "react";
import { Button } from "antd";
import * as S from "./styled";

interface IFooterFormProps {
  cancelbuttontxt?: string;
  showCancelButton?: boolean;
  confirmbuttontxt?: string;
  showConfirmButton?: boolean;
  onConfirm?: (ev) => void;
  customrenderconfirmbutton?: JSX.Element;
  customrendercancelbutton?: JSX.Element;
}

interface IFooterProps {
  cancelbuttontxt?: string;
  showCancelButton?: boolean;
  confirmbuttontxt?: string;
  showConfirmButton?: boolean;
  onConfirm?: (ev) => void;
  customrenderconfirmbutton?: JSX.Element;
  customrendercancelbutton?: JSX.Element;
}

const Footer = (props: IFooterProps) => {
  return (
    <S.DrawerFooter>
      <div className="text-left">
        {props.showCancelButton && !props.customrendercancelbutton && <Button className="btnCancel">{props.cancelbuttontxt}</Button>}
        {props.customrendercancelbutton !== null && props.customrendercancelbutton}
      </div>
      <div className="text-right">
        {props.showConfirmButton && !props.customrenderconfirmbutton && (
          <Button type="primary" onClick={props.onConfirm} className="btn">
            {props.confirmbuttontxt}
          </Button>
        )}
        {props.customrenderconfirmbutton !== null && props.customrenderconfirmbutton}
      </div>
    </S.DrawerFooter>
  );
};

Footer.defaultProps = {
  cancelbuttontxt: "cancel",
  showCancelButton: true,
  confirmbuttontxt: "Ok",
  showConfirmButton: true,
};

const YmsFooterForm = (props: IFooterFormProps) => {
  return (
    <Footer
      {...props}
      cancelbuttontxt={props.cancelbuttontxt}
      showCancelButton={props.showCancelButton}
      confirmbuttontxt={props.confirmbuttontxt}
      showConfirmButton={props.showConfirmButton}
      onConfirm={props.onConfirm}
      customrenderconfirmbutton={props.customrenderconfirmbutton}
      customrendercancelbutton={props.customrendercancelbutton}
    />
  );
};

YmsFooterForm.defaultProps = {
  title: "Default title",
};

export default YmsFooterForm;
